import type { EntryStatus } from "@eaub/shared";

export function StatusBadge({ status }: { status: EntryStatus }) {
  const className = status === "published" ? "badge badge--success" : "badge badge--muted";
  return <span className={className}>{status}</span>;
}

export function UnpublishedChangesBadge() {
  return (
    <span className="badge badge--warning" title="Draft has unpublished changes">
      unpublished changes
    </span>
  );
}
